export abstract class IDisposable {
    public abstract dispose(): void;
}

export abstract class IDisposableAsync {
    public abstract dispose(): Promise<void>;
}
